import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    ciudad: '',
    servicio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6q7l35sbgrc47fim2bg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          ciudad: '',
          servicio: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/18594205881?text=Hola%2C%20necesito%20información%20sobre%20sus%20servicios', '_blank');
  };

  return (
    <section id="contact-section" className="py-20 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Empieza hoy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Déjanos tu información y uno de nuestros asesores se pondrá en contacto contigo para ayudarte con tu trámite.
          </p>
          <p className="text-lg text-gray-600 mt-4">
            También puedes enviarnos un mensaje directo por WhatsApp y con gusto te orientaremos.
          </p>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-xl p-8 border border-gray-100">
            <form id="paisanet-contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                  Nombre completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm"
                  placeholder="(555) 123-4567"
                />
              </div>

              <div>
                <label htmlFor="ciudad" className="block text-sm font-semibold text-gray-700 mb-2">
                  Ciudad *
                </label>
                <input
                  type="text"
                  id="ciudad"
                  name="ciudad"
                  value={formData.ciudad}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm"
                  placeholder="Tu ciudad en Kentucky"
                />
              </div>

              <div>
                <label htmlFor="servicio" className="block text-sm font-semibold text-gray-700 mb-2">
                  Servicio que necesitas *
                </label>
                <select
                  id="servicio"
                  name="servicio"
                  value={formData.servicio}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm cursor-pointer"
                >
                  <option value="">Selecciona un servicio</option>
                  <option value="Creación de LLC">Creación de LLC</option>
                  <option value="Obtención de EIN">Obtención de EIN</option>
                  <option value="Registro de vehículos y placas">Registro de vehículos y placas</option>
                  <option value="Reparación de crédito">Reparación de crédito</option>
                  <option value="Créditos para negocios">Créditos para negocios</option>
                  <option value="Asesoría para emprendedores">Asesoría para emprendedores</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                  ¡Gracias! Hemos recibido tu información. Nos pondremos en contacto contigo pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                  Hubo un error al enviar el formulario. Por favor, intenta de nuevo o contáctanos por WhatsApp.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Quiero empezar'}
              </button>
            </form>
          </div>

          {/* Contact Info & WhatsApp */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-lg shadow-xl p-8 text-white">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-white/20 rounded-lg flex items-center justify-center">
                  <i className="ri-whatsapp-line text-4xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold">¿Prefieres WhatsApp?</h3>
                  <p className="text-white/90">Respuesta inmediata</p>
                </div>
              </div>
              <p className="mb-6 text-white/95">
                Envíanos un mensaje y te responderemos de inmediato para ayudarte con tu trámite.
              </p>
              <button
                onClick={handleWhatsApp}
                className="w-full bg-white text-green-600 px-6 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Enviar mensaje por WhatsApp
              </button>
            </div>

            <div className="bg-white rounded-lg shadow-xl p-8 border border-gray-100 space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Ubicación</h4>
                  <p className="text-gray-600">Kentucky, Estados Unidos</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Horario</h4>
                  <p className="text-gray-600">Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                  <p className="text-gray-600">Sábados: 10:00 AM - 2:00 PM</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Atención</h4>
                  <p className="text-gray-600">Servicio en español e inglés</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}